import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import {
  backgroundLight,
  primaryAlt,
  textPrimary,
  textSecondary,
} from "../../../../../utils/colors";
import { useTranslation } from "react-i18next";

const PatientPortalNoPlans = ({ clinicName }) => {
  const { t } = useTranslation();

  return (
    <>
      <Flex
        w="100%"
        maxW={["100%", "1200px"]}
        m="0 auto"
        direction="column"
        p="3rem 0 0"
      >
        <Flex
          w="100%"
          align="center"
          justify="center"
          maxW={["90%", "800px"]}
          m="0 auto"
          direction="column"
        >
          <Text fontSize="2rem" color={textPrimary} fontWeight="500">
            {t("patient.patientPortal")}
          </Text>
          <Text
            fontSize="2rem"
            color={primaryAlt}
            fontWeight="500"
            textAlign="center"
          >
            {clinicName && clinicName}
          </Text>
        </Flex>

        <Flex
          w="100%"
          direction="column"
          bg={backgroundLight}
          borderRadius="2rem"
          p="4rem 2rem"
          h="100%"
          maxW={["100%", "800px"]}
          m="2rem auto 0"
          align="center"
          justify="center"
        >
          <Text
            fontSize="1.25rem"
            color={textPrimary}
            fontWeight="500"
            mt="1rem"
          >
            {t("patient.portalNoPlansTitle")}
          </Text>
          <Text
            fontSize="1rem"
            color={textSecondary}
            fontWeight="500"
            textAlign="center"
            mt="0.5rem"
            maxW="400px"
          >
            {t("patient.portalNoPlansText")}
          </Text>
        </Flex>
      </Flex>
    </>
  );
};

export default PatientPortalNoPlans;
